/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_Folder_Move_HomeInputs */

const en_dialog_delete_folder_move_home = /** @type {(inputs: Dialog_Delete_Folder_Move_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete folder and move files to home`)
};

const es_dialog_delete_folder_move_home = /** @type {(inputs: Dialog_Delete_Folder_Move_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar carpeta y mover archivos al inicio`)
};

/**
* | output |
* | --- |
* | "Delete folder and move files to home" |
*
* @param {Dialog_Delete_Folder_Move_HomeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_folder_move_home = /** @type {((inputs?: Dialog_Delete_Folder_Move_HomeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Folder_Move_HomeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_folder_move_home(inputs)
	return en_dialog_delete_folder_move_home(inputs)
});